var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCreate = function SvgCreate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".create_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.501 18.5 15 5.997l3.001 3L5.503 21.5zM13.56 16.608 21 23.5c2 0 2.5-.5 2.5-2.5l-7.959-6.308M22.5 4.5a2.213 2.213 0 0 1 0 3l-5 5M2.25 21.75.5 23.5",
    className: "create_svg__a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6 20.5.5l3 3L18 9zM3.249 19.25 1.5 20.999 3 22.5l1.75-1.75M3 .5c-.183 3.741 3.217 3.281 4.68 4.371a3.559 3.559 0 0 1 .719 4.947C4.647 14.842-2.593 5.9 3 .5",
    className: "create_svg__a"
  })));
};
export default SvgCreate;